module.exports = "img/flags/GE.93fd053.png";